import { render, staticRenderFns } from "./ClaimGuideTab.vue?vue&type=template&id=550873f6&scoped=true&"
import script from "./ClaimGuideTab.vue?vue&type=script&lang=js&"
export * from "./ClaimGuideTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550873f6",
  null
  
)

export default component.exports